



































import { CampaignFormData, AdgroupFormData, AdgroupListItem, AdgroupConfig } from '@tt4b/ttam-enums';
import { defineComponent, ref, computed, PropType, toRefs } from '@vue/composition-api';
import promotion from './index';
import ALink from '@/components/common/a-link/a-link.vue';
import { usePromotionAppValidate, useStore, StateEnum } from '@tt4b/ttam-hooks';
import { DataItem } from './types';

const name = 'ttam-promotion';
export default defineComponent({
  name,
  components: {
    TtamPromotionApp: promotion.TtamPromotionApp,
    TtamPromotionAppTips: promotion.TtamPromotionAppTips,
    TtamPromotionAppIosTips: promotion.TtamPromotionAppIosTips,
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    dcAdgroupList: {
      type: Array as PropType<AdgroupListItem[]>,
      default: () => [],
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const formItem = ref(null);
    const { adgroupData, campaignData, dcAdgroupList, adgroupConfig } = toRefs(props);
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);

    // promotion-app
    const addUrl = `/i18n/events_manager/app?aadvid=${aadvid.value}`;
    const { disabled } = promotion.usePropsDisabled({
      dcAdgroupList,
      adgroupData,
      campaignData,
      adgroupConfig,
    });
    const { isEmpty, loading, dataSource, loadData, originalData } = promotion.useDataSource({
      adgroupData,
      campaignData,
    });
    const adRefAppId = ref(adgroupData.value.adRefAppId);

    const onInput = (id: string) => {
      adRefAppId.value = id;
      emit('input', id);
      // 手动触发校验更新
      setTimeout(() => formItem.value?.validate('change'), 0);
    };
    const onChange = (item: DataItem) => {
      emit('change', item);
    };
    const onRefresh = () => {
      loadData();
    };
    const curAppItem = computed(() => originalData.value?.find(i => i.Id === adRefAppId.value));
    const { adRefAppIdValidator } = usePromotionAppValidate({ selectedApp: curAppItem });
    const { isShowInfo } = promotion.usePropsRetargetingInfo({
      adgroupData,
      campaignData,
    });
    const showInfoTips = computed(() => isShowInfo.value);
    const { ios14TipsVisible } = promotion.usePropsIOS14Visible({
      adgroupData,
      item: curAppItem,
    });

    return {
      name,
      formItem,
      addUrl,
      disabled,
      isEmpty,
      loading,
      adRefAppId,
      dataSource,
      showInfoTips,
      ios14TipsVisible,
      adRefAppIdValidator,
      onInput,
      onRefresh,
      onChange,
    };
  },
});
